enum ScreensetType {
    signIn,
    forgotPassword,
    resetPasswordRequestCode,
    register,
}

export { ScreensetType };
